import { render, staticRenderFns } from "./PaymentStatistics.vue?vue&type=template&id=2d41f835&scoped=true&"
import script from "./PaymentStatistics.vue?vue&type=script&lang=js&"
export * from "./PaymentStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41f835",
  null
  
)

export default component.exports